<template>
  <div id="prizes-arrow" class="prizes-arrow" @click="scrollToPrizes()">
    <div class="text">Prizes</div>
    <div class="arrows"></div>
  </div>
</template>

<script>
export default {
  methods: {
    scrollToPrizes() {
      document.querySelector("#competition-prizes").scrollIntoView({
        block: "start",
        behavior: "smooth"
      });
    }
  }
};
</script>

<style lang="scss">
.prizes-arrow {
  position: absolute;
  top: calc(50% - 60px);
  left: -200px;
  color: currentColor;
  cursor: pointer;
  user-select: none;
  text-transform: uppercase;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  background-image: url("~@/assets/circle-bg.png");
  background-repeat: no-repeat;
  width: 140px;
  height: 140px;
  transition: 100ms ease-in-out;
  &:hover {
    transform: scale(1.1);
  }
  &:active {
    transform: scale(0.9);
  }
  .text {
    margin-top: 0.625rem;
  }
  .arrows {
    &::before {
      content: ">>";
    }
    letter-spacing: -7px;
    font-size: 1rem;
    transform: rotate(90deg);
  }
}

@media (max-width: 1220px) {
  .prizes-arrow {
    display: none;
  }
}
</style>